module.exports = [{
      plugin: require('/Users/john/Lab/clients/test/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
